import * as React from 'react';
export const IcBloodTest = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11 14.52a5.43 5.43 0 011.62-3.89L14 9.26V5h.5a1.5 1.5 0 000-3h-9a1.5 1.5 0 000 3H6v13a4 4 0 007.78 1.26A5.37 5.37 0 0111 14.52zM8 9V5h4v4H8zm11 3.05l-1.76-1.76a1.002 1.002 0 00-1.42 0L14 12.05A3.481 3.481 0 0014 17a3.51 3.51 0 005 0 3.4 3.4 0 001-2.46 3.46 3.46 0 00-1-2.49z'
      fill='currentColor'
    />
  </svg>
);
